export default __webpack_public_path__ + "static/media/ksztalty-gluten lactose free.793b8cef.svg";